import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';
import { LoaderSpinner, Text, TextProps } from '@companion-professional/components';

interface LoadingMessageProps {
  // children is the message displayed next to the spinner (e.g. "Creating Checkup...").
  children: React.ReactNode;

  // size is the text size of the message.  Defaults to the standard body size (md).
  size?: TextProps['size'];

  // className can be used to add additional (layout) classes to the wrapper, e.g. margins or alignment.
  className?: string;
}

// LoadingMessage is a small inline spinner followed by a muted status message.  Use it for in-place progress
// indicators (e.g. while a checkup is being created) where a full QueryLoaderWrapper spinner would be too heavy.
export const LoadingMessage: FunctionComponent<LoadingMessageProps> = ({ children, size, className }) => {
  return (
    <div className={cn('flex flex-row items-center', className)}>
      <LoaderSpinner size="small" />
      <Text as="span" tone="muted" size={size}>
        {children}
      </Text>
    </div>
  );
};
